import React from 'react';
import { useTranslation } from 'react-i18next';
import { APP_NAME } from '../../constants';
import adobeWordmark from './WelcomeAdobeWordmark.svg';
import welcomeIllustration from './WelcomeIllustration.svg';
import './Hero.css';

interface WelcomeViewProps {
  error: string | null;
  onLogin: () => void;
}

export const WelcomeView: React.FC<WelcomeViewProps> = ({ error, onLogin }) => {
  const { t } = useTranslation();
  return (
  <div className="gkai-landing">
    <header className="gkai-nav">
      <img
        className="gkai-adobe-wordmark"
        src={adobeWordmark}
        alt={t('settings.welcome.adobeAlt')}
        width={164}
        height={40}
      />
    </header>

    <section className="gkai-hero" aria-labelledby="welcome-title">
      <div className="gkai-hero-inner">
        <h1 id="welcome-title" className="gkai-hero-title">
          {t('settings.welcome.title', { appName: APP_NAME })}
        </h1>
        <p className="gkai-lede">{t('settings.welcome.lede')}</p>
        <p className="gkai-principle">
          {t('settings.welcome.principle')}
        </p>

        {error && <div className="gkai-hero-error" role="alert">{error}</div>}

        <button type="button" className="gkai-sign-in" onClick={onLogin}>
          {t('settings.welcome.signIn')}
        </button>

        <img
          className="gkai-hero-illustration"
          src={welcomeIllustration}
          alt={t('settings.welcome.illustrationAlt')}
          width={1409}
          height={411}
        />
      </div>
    </section>

    <footer className="gkai-hero-footer">
      <span>{t('settings.welcome.copyright')}</span>
      <div className="gkai-footer-links">
        <a href="https://www.adobe.com/legal/terms-linkfree.html" target="_blank" rel="noopener noreferrer">{t('settings.welcome.termsOfUse')}</a>
        <span className="gkai-footer-divider" aria-hidden="true" />
        <a href="https://www.adobe.com/privacy/policy-linkfree.html" target="_blank" rel="noopener noreferrer">{t('settings.welcome.privacy')}</a>
        <span className="gkai-footer-divider" aria-hidden="true" />
        <a href="https://www.adobe.com/privacy/location-specific-notice-linkfree.html" target="_blank" rel="noopener noreferrer">{t('settings.welcome.doNotSell')}</a>
      </div>
    </footer>
  </div>
  );
};
